import React, { useState, useEffect } from 'react';

import LoginForm from './Auth/LoginForm';
import PosterBlock from './Auth/PosterBlock';
import PopupBanner from './PopupBanner';

import { GET_EVENTS } from '../constants/apiConstant';
import UtilService from '../services/util';

const SignIn = (props) => {
  const [PopupPageData, setPopupPageData] = useState([]);

  const getLandingPageNewsData = () => {
    const obj = {
      ...GET_EVENTS,
      request: {
        page: 1,
        limit: 100,
        isDeleted: false,
        isActive: true,
        type: '6',
      },
    };
    UtilService.callApi(obj, (err, data) => {
      if (err) {
        setPopupPageData(undefined);
      } else if (data && data.code === 'OK') {
        if (data.data.list) {
          const sorted = data.data.list.map((x) => (x.type === '6' && x.isActive ? x.images : [])).flat();
          setPopupPageData(sorted);
        }
      } else {
        setPopupPageData(undefined);
      }
    });
  };

  useEffect(() => {
    getLandingPageNewsData();
  }, []);

  return (
    <>
      {PopupPageData && PopupPageData.length > 0 && <PopupBanner PopupPageData={PopupPageData} />}
      <div className="loginMainWrapper">
        <PosterBlock left={require('../assets/img/login/login-bg.png')} />
        <div className="LoginRightBlock">
          <LoginForm history={props.history} />
        </div>
        {/* <PosterBlock left={require('../assets/img/login/3.jpg')} /> */}
      </div>
    </>
  );
};

export default SignIn;
